module.exports = __webpack_public_path__ + "img/world.east.contoured.baac86fb.svg";